import LZUTF8 from 'lzutf8';
import * as Form from './finalthesis';
import uischemaJson from './finalthesis.uischema.json';

import examiners from './examiners.json';
import Ajv from "ajv";
import {RuleEffect} from "@jsonforms/core";


export const FORM_NAME = 'umr-fb12-finalthesis';
export const FORM_VERSION = '1.0.2';
export const FORM_DATE = '2026-01-20';

export const EMPTY_FORM_DATA : Form.AnmeldungDerAbschlussarbeit = {
    requirements_bsc_cs_23: {},
    requirements_bsc_ds_23: {},
    requirements_bsc_bi_23: {},
    requirements_bsc_m_23: {},
    requirements_bsc_bm_23: {},
    requirements_msc_cs_23: {},
    requirements_msc_ds_23: {},
    requirements_msc_bi_23: {},
    requirements_msc_m_23: {},
    requirements_msc_bm_23: {},
    requirements_bsc_cs_18: {},
    requirements_bsc_ds_18: {},
    requirements_bsc_bi_18: {},
    requirements_bsc_m_18: {},
    requirements_bsc_bm_18: {},
    requirements_msc_cs_18: {},
    requirements_msc_ds_18: {},
    requirements_msc_bi_18: {},
    requirements_msc_m_18: {},
    requirements_msc_bm_18: {},
    requirements_other: {},
    lastname: undefined,
    firstname: undefined,
    studentid: undefined,
    birthday: undefined,
    birthplace: undefined,
    email: undefined,
    phone: undefined,
    username: undefined,
    subject: undefined,
    degree: undefined,
    exam_regulations: undefined,
    supervisor: undefined,
    second_supervisor: undefined,
    title: undefined,
    start_date: undefined,
    comment: undefined
};

export type FormKey = keyof Form.AnmeldungDerAbschlussarbeit;

export const LOCAL_STORE_KEY_FORM_DATA = 'formData';
export const LOCAL_STORE_KEY_LANG = 'lang';

export function getInitialFormData() : Form.AnmeldungDerAbschlussarbeit {
	const parameterValue = new URLSearchParams(document.location.search).get(LOCAL_STORE_KEY_FORM_DATA);
	const localStoreageValue = localStorage.getItem(LOCAL_STORE_KEY_FORM_DATA);

	if (parameterValue !== undefined && parameterValue !== null) {
		const compressedFormData = decodeURIComponent(parameterValue);
		return JSON.parse(LZUTF8.decompress(compressedFormData, { inputEncoding: 'Base64' }));
	} else if (localStoreageValue !== undefined && localStoreageValue !== null) {
		return JSON.parse(localStoreageValue);
	} else {
		return EMPTY_FORM_DATA;
	}
}

export function getInitialLang() : string {
	const parameterValue = new URLSearchParams(document.location.search).get(LOCAL_STORE_KEY_LANG);
	const localStoreageValue = localStorage.getItem(LOCAL_STORE_KEY_LANG);

	if (parameterValue !== undefined && parameterValue !== null) {
		return parameterValue;
	} else if (localStoreageValue !== undefined && localStoreageValue !== null) {
		return localStoreageValue;
	} else {
		return 'de';
	}
}

export function editLink(formData : Form.AnmeldungDerAbschlussarbeit, lang : string) {
	const formDataCompressed = LZUTF8.compress(JSON.stringify(formData), { outputEncoding: 'Base64' });
	return document.location.origin + document.location.pathname + '?lang=' + lang + '&formData=' + encodeURIComponent(formDataCompressed);
}

export function csvData(formData : Form.AnmeldungDerAbschlussarbeit, subject : string | undefined, degree : string | undefined, exam_regulations : string | undefined, lang : string, requirementsFulfilled : boolean) {
	// when changing the csv representation, at least increase the minor version number of FORM_VERSION
	const agreeAlumni = formData.agreement_alumni === true;
	const supervisorName = getSupervisorName(formData);
	const secondSupervisorName = getSecondSupervisorName(formData);
	const supervisor = examiners.find(examiner => examiner.displayName === supervisorName)?.sortName ?? supervisorName;
	const secondSupervisor = examiners.find(examiner => examiner.displayName === secondSupervisorName)?.sortName ?? secondSupervisorName;

	const examRegulationsParts = exam_regulations !== undefined ? exam_regulations.split(" ") : ["", "unknown", "0000"];

	let exam_regulations_short = examRegulationsParts[2].substring(0, 4);
	if (examRegulationsParts[1].toLowerCase().startsWith("s"))
		exam_regulations_short = exam_regulations_short + "1";
	else if (examRegulationsParts[1].toLowerCase().startsWith("w"))
		exam_regulations_short = exam_regulations_short + "2";
	else
		exam_regulations_short = exam_regulations_short + "0";

	const titlesDeEn = [];
	if (subject && subject.indexOf('/') > -1) {
		const split = subject.split('/');
		titlesDeEn[0] = split[0];
		titlesDeEn[1] = split[1];
	} else if (subject) {
		titlesDeEn[0] = subject;
		titlesDeEn[1] = subject;
	} else {
		titlesDeEn[0] = "<missing>";
		titlesDeEn[1] = "<missing>";
	}
	const subject_official = degree === 'Bachelor' ? titlesDeEn[0] : titlesDeEn[1];

	
	return (
		// CSV headers
		// Prüfer	AG	Zweitprüfer	Matrikelnummer	Name	Vorname	Studiengang	Abschluss	PO	Thema	Ausgabe Thema	Abgabedatum	Verlängerung	2. Verlängerung	tatsächliche Abgabe	Termin Erstgutachten	Eingang Erstgutachten	Disputation	Datum Abschluss	Zeugnis ausgestellt	Zeugnisausgabe	E-Mail	Private E-Mail	Telefon	Zustimmung Alumni	Heimatadresse	Bevorzugte Sprache	Geburtstag	Geburtsort	Zulassungsvoraussetzungen	Kommentar	Formular Version
		excelEscape(orEmpty(supervisor)) + '\t' +
		'\t' + // AG
		excelEscape(orEmpty(secondSupervisor)) + '\t' +
		excelEscape(orEmpty(formData.studentid)) + '\t' +
		excelEscape(orEmpty(formData.lastname)) + '\t' +
		excelEscape(orEmpty(formData.firstname)) + '\t' +
		excelEscape(orEmpty(subject_official)) + '\t' +
		excelEscape(orEmpty(degree)) + '\t' +
		excelEscape(orEmpty(exam_regulations_short)) + '\t' +
		excelEscape(orEmpty(formData.title)) + '\t' +
		excelEscape(orEmpty(formData.start_date)) + '\t' +
		'\t' + // Abgabedatum
		'\t' + // Verlängerung
		'\t' + // 2. Verlängerung
		'\t' + // tatsächliche Abgabe
		'\t' + // Termin Erstgutachten
		'\t' + // Eingang Erstgutachten
		'\t' + // Disputation
		'\t' + // Datum Abschluss
		'\t' + // Zeugnis ausgestellt
		'\t' + // Zeugnisausgabe
		excelEscape(orEmpty(formData.username + '@students.uni-marburg.de')) + '\t' + // offizielle E-Mail
		excelEscape(orEmpty(agreeAlumni ? formData.email : undefined)) + '\t' + // Private E-Mail
		excelEscape(orEmpty(agreeAlumni ? formData.phone : undefined)) + '\t' +  // Telefon
		excelEscape((agreeAlumni ? 'TRUE' : 'FALSE')) + '\t' + // Zustimmung Datenspeicherung
		excelEscape(orEmpty(agreeAlumni ? formData.home_address : undefined)) + '\t' +  // Heimatadresse
		excelEscape(orEmpty(lang)) + '\t' +  // Bevorzugte Sprache
		excelEscape(orEmpty(formData.birthday)) + '\t' + // Geburtstag
		excelEscape(orEmpty(formData.birthplace)) + '\t' + // Geburtsort
		excelEscape(orEmpty(requirementsFulfilled ? 'zugelassen' : 'nicht zugelassen')) + '\t' + // Zulassungsvoraussetzungen erfüllt
		excelEscape((formData.external ? '[EXTERN]' : '') + orEmpty(formData.comment)) + '\t' + // Kommentar
		excelEscape(FORM_NAME + '_' + FORM_VERSION + '_' + FORM_DATE));
}

function orEmpty(value: string | number | undefined) {
	if (value === undefined)
		return '';
	else if (typeof value === "number")
		return value.toString();
	else
		return value;
}

function excelEscape(string: string) {
	return '\'' + string;
}
export function getSupervisorName(formData : Form.AnmeldungDerAbschlussarbeit) {
	return formData.supervisor === 'Andere(r)' ? formData.supervisor_other : formData.supervisor;
}

export function getSecondSupervisorName(formData : Form.AnmeldungDerAbschlussarbeit) {
	return formData.second_supervisor === 'Andere(r)' ? formData.second_supervisor_other : formData.second_supervisor;
}

export function getSubject(formData : Form.AnmeldungDerAbschlussarbeit) {
	return formData.subject;	
}

export function getDegree(formData : Form.AnmeldungDerAbschlussarbeit) {
	return formData.degree;	
}

export function getExamRegulations(formData : Form.AnmeldungDerAbschlussarbeit) {
	return formData.exam_regulations === 'Andere' ? formData.exam_regulations_other : formData.exam_regulations;
}

export function getRequirementsPropertyName(formData : Form.AnmeldungDerAbschlussarbeit) {
	const ajv = new Ajv();
	const requirementUiElement = uischemaJson.elements.find(elem => {
			if (elem.scope?.startsWith("#/properties/requirements_")) {
				const rule = elem.rule;
				// assume that rule scope is the whole object
				if (rule.condition.scope === "#") {
					const satisfied = ajv.validate(rule.condition.schema, formData);
					if (satisfied && rule.effect === RuleEffect.SHOW || !satisfied && rule.effect === RuleEffect.HIDE) {
						return true;
					}
				}
			}
		});
	if (requirementUiElement === undefined || requirementUiElement.scope == undefined) {
		return undefined;
	} else {
		return requirementUiElement.scope.substring("#/properties/".length);
	}
}